/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const data = {
    header: {
        title: '#<strong>FloralHeartProject</strong> Memorial Map',
        description: 'On March 1, 2021 we laid memorial wreaths across the country commemorating those we’ve lost to COVID-19.',
    },
    back_button: {
        title: '< Back to Floral Heart Project Memorial page',
        link: '/floral-heart-project',
    },
    map_title: 'See the memorials that happened near you along with participating cities, on the map below.',
    banner_image: {
        path: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt25fe85ead27261ba/63501f16edc241215e340134/static-map.jpg',
        alt: 'Banner',
    },
    map_url: 'https://www.google.com/maps/d/u/0/embed?mid=1dOiKRmMaLxp2g9aOe_Vs9w4QLoz2-uLV',
    table: [
        {
            mobile_state_name: 'AZ',
            state: 'Arizona',
            city: 'Phoenix',
            location: {
                title: 'National Heritage Society Museum',
                sub_title: '1300 N College Ave, Tempe, AZ 85281',
            },
        },
        {
            mobile_state_name: 'AK',
            state: 'Arkansas',
            city: 'Pea Ridge, Bentonville, Fayetteville',
            location: {
                title: 'Walmart Neighborhood Market',
                sub_title: '240 Slack St, Pea Ridge, AR 72751',
            },
        },
        {
            mobile_state_name: 'CA',
            state: 'California',
            city: 'Carlsbad',
            location: {
                title: 'South Ponto Beach',
                sub_title: '',
            },
        },
        {
            mobile_state_name: 'CA',
            state: 'California',
            city: 'Santa Monica',
            location: {
                title: 'Palisades Park Ocean and Montana',
                sub_title: 'Ocean Ave, Santa Monica, CA 90401',
            },
        },
        {
            mobile_state_name: 'CA',
            state: 'California',
            city: 'Los Angeles',
            location: {
                title: 'Building Bridges Gallery',
                sub_title: '2525 Michigan Ave f2, Santa Monica, CA 90404',
            },
        },
        {
            mobile_state_name: 'CA',
            state: 'California',
            city: 'Temecula',
            location: {
                title: 'Temecula City Hall',
                sub_title: '41000 Main St, Temecula, CA 92590',
            },
        },
        {
            mobile_state_name: 'CA',
            state: 'California',
            city: 'San Luis Obispo',
            location: {
                title: 'Mission Plaza',
                sub_title: '989 Chorro St, San Luis Obispo, CA 93401',
            },
        },
        {
            mobile_state_name: 'FL',
            state: 'Florida',
            city: 'Ft Lauderdale',
            location: {
                title: 'Westchester of Sunrise',
                sub_title: '9701 W Oakland Park Blvd, Sunrise, FL 33351',
            },
        },
        {
            mobile_state_name: 'FL',
            state: 'Florida',
            city: 'Ocala',
            location: {
                title: 'Ocala Downtown Square',
                sub_title: 'Ocala, FL',
            },
        },
        {
            mobile_state_name: 'FL',
            state: 'Florida',
            city: 'Indialantic',
            location: {
                title: 'James H. Nance Park',
                sub_title: '',
            },
        },
        {
            mobile_state_name: 'GA',
            state: 'Georgia',
            city: 'Atlanta',
            location: {
                title: 'The Beltline',
                sub_title: '(at the intersection of Ponce City Market access road)',
            },
        },
        {
            mobile_state_name: 'IL',
            state: 'Illinois',
            city: 'Evanston',
            location: {
                title: 'NorthShore Evanston Hospital,',
                sub_title: 'Amita St Francis Hospital',
            },
        },
        {
            mobile_state_name: 'KY',
            state: 'Kentucky',
            city: 'Florence',
            location: {
                title: 'Florence Community Plaza',
                sub_title: '8001 Mall Rd, Florence, KY 41042',
            },
        },
        {
            mobile_state_name: 'KY',
            state: 'Kentucky',
            city: 'Paris',
            location: {
                title: 'Courthouse Steps',
                sub_title: '301 Main St # 203, Paris, KY 40361',
            },
        },
        {
            mobile_state_name: 'ME',
            state: 'Maine',
            city: 'Portland',
            location: {
                title: 'Lobsterman’s Park',
                sub_title: '1 Temple St, Portland, ME 04101',
            },
        },
        {
            mobile_state_name: 'ME',
            state: 'Maine',
            city: 'Augusta',
            location: {
                title: 'State House',
                sub_title: '210 State St, Augusta, ME 0433',
            },
        },
        {
            mobile_state_name: 'ME',
            state: 'Maine',
            city: 'Penobscot Count',
            location: {
                title: 'Khatadin Scenic Overlook',
                sub_title: 'Medway, ME 04460',
            },
        },
        {
            mobile_state_name: 'MD',
            state: 'Maryland',
            city: 'Baltimore',
            location: {
                title: 'Baltimore City Hall',
                sub_title: '100 Holliday St, Baltimore, MD 21202',
            },
        },
        {
            mobile_state_name: 'MD',
            state: 'Maryland',
            city: 'Silver Spring',
            location: {
                title: 'Fountain in Downtown',
                sub_title: '916 Ellswoth Drive Silver Spring,MD',
            },
        },
        {
            mobile_state_name: 'MA',
            state: 'Massachusetts',
            city: 'Cambridge',
            location: {
                title: 'Fresh Pond Reservation',
                sub_title: '180-220 Fresh Pond Pkwy, Cambridge, MA 02138',
            },
        },
        {
            mobile_state_name: 'MA',
            state: 'Massachusetts',
            city: 'Natick',
            location: {
                title: 'Natick Center Common',
                sub_title: '12 S Main St, Natick, MA 01760',
            },
        },
        {
            mobile_state_name: 'MA',
            state: 'Massachusetts',
            city: 'Boston',
            location: {
                title: 'Pathway to the Public Gardens',
                sub_title: '',
            },
        },
        {
            mobile_state_name: 'MI',
            state: 'Michigan',
            city: 'Sault Ste Marie',
            location: {
                title: 'City Hall',
                sub_title: '225 E Portage Avenue Sault Ste. Marie, MI 49783',
            },
        },
        {
            mobile_state_name: 'MS',
            state: 'Mississippi',
            city: 'Jackson',
            location: {
                title: 'University of Mississippi Medical Center',
                sub_title: '2500 North State Street Jackson, MI 39216',
            },
        },
        {
            mobile_state_name: 'MS',
            state: 'Mississippi',
            city: 'Como',
            location: {
                title: 'Main Street',
                sub_title: '',
            },
        },
        {
            mobile_state_name: 'NV',
            state: 'Nevada',
            city: 'Las Vegas',
            location: {
                title: 'Las Vegas Sign',
                sub_title: '5200 Las Vegas Blvd S, Las Vegas, NV 89119',
            },
        },
        {
            mobile_state_name: 'NH',
            state: 'New Hamisphere',
            city: 'Tilton',
            location: {
                title: 'New Hampshire Veterans’ Home',
                sub_title: '139 Winter St, Tilton, NH 03276',
            },
        },
        {
            mobile_state_name: 'NJ',
            state: 'New Jersey',
            city: 'Passaic',
            location: {
                title: 'St. Mary’s Hospital',
                sub_title: '350 Boulevard, Passaic, NJ 07055',
            },
        },
        {
            mobile_state_name: 'NJ',
            state: 'New Jersey',
            city: 'Passaic',
            location: {
                title: 'Passaic Westside Fire Station',
                sub_title: '352 Paulison Ave Passaic NJ 07055',
            },
        },
        {
            mobile_state_name: 'NJ',
            state: 'New Jersey',
            city: 'Passaic',
            location: {
                title: 'EMS Building',
                sub_title: '54 Grove Street Passaic NJ',
            },
        },
        {
            mobile_state_name: 'OK',
            state: 'Oklahoma',
            city: 'Oklahoma City',
            location: {
                title: 'Plenty Mercantile',
                sub_title: '807 N Broadway Ave, Oklahoma City, OK 73102',
            },
        },
        {
            mobile_state_name: 'OK',
            state: 'Oklahoma',
            city: 'Oklahoma City',
            location: {
                title: 'Myriad Botanical Gardens',
                sub_title: '301 W Reno Ave, Oklahoma City, OK 73102',
            },
        },
        {
            mobile_state_name: 'OK',
            state: 'Oklahoma',
            city: 'Oklahoma City',
            location: {
                title: 'Scissortail Park',
                sub_title: '300 SW 7th St, Oklahoma City, OK 73109',
            },
        },
        {
            mobile_state_name: 'OR',
            state: 'Oregon',
            city: 'Portland',
            location: {
                title: 'Pioneer Square',
                sub_title: '',
            },
        },
        {
            mobile_state_name: 'PA',
            state: 'Pennsylvania',
            city: 'Philadelphia',
            location: {
                title: 'Love Park',
                sub_title: 'Arch St, Philadelphia, PA 19102',
            },
        },
        {
            mobile_state_name: 'PA',
            state: 'Pennsylvania',
            city: 'Philadelphia',
            location: {
                title: 'Rittenhouse Square',
                sub_title: '210 W Rittenhouse Square, Philadelphia, PA 1910',
            },
        },
        {
            mobile_state_name: 'PA',
            state: 'Pennsylvania',
            city: 'Luzerne County',
            location: {
                title: 'Luzerne County Courthouse',
                sub_title: '200 N River St, Wilkes-Barre, PA 18711',
            },
        },
        {
            mobile_state_name: 'TX',
            state: 'Texas',
            city: 'Dallas',
            location: {
                title: 'AT&T Discovery District',
                sub_title: '308 S Akard St, Dallas, TX 75202',
            },
        },
        {
            mobile_state_name: 'TX',
            state: 'Texas',
            city: 'DeSoto',
            location: {
                title: 'Quality Care Health Clinics',
                sub_title: '1110 E. Pleasant Run Road, DeSoto, TX 75115',
            },
        },
        {
            mobile_state_name: 'TX',
            state: 'Texas',
            city: 'Lewisville',
            location: {
                title: 'Quality Care Health Clinics',
                sub_title: '11140 W. Main Street 75067',
            },
        },
        {
            mobile_state_name: 'TX',
            state: 'Texas',
            city: 'Austin',
            location: {
                title: 'UMLAUF Sculpture Garden',
                sub_title: '605 Azie Morton Rd, Austin, TX 78704',
            },
        },
        {
            mobile_state_name: 'TX',
            state: 'Texas',
            city: 'El Paso',
            location: {
                title: 'San Jacinto Plaza',
                sub_title: '114 W Mills Ave, El Paso, TX 79901',
            },
        },
        {
            mobile_state_name: 'VT',
            state: 'Vermont',
            city: 'Burlington',
            location: {
                title: 'Church St Marketplace',
                sub_title: '2 Church St Suite 2A, Burlington, VT 05401',
            },
        },
        {
            mobile_state_name: 'VA',
            state: 'Virginia',
            city: 'Lynchburg',
            location: {
                title: 'Love Shoe Sculpture - Craddock Terry Hotel',
                sub_title: '1312 Commerce St, Lynchburg, VA 24504',
            },
        },
        {
            mobile_state_name: 'DC',
            state: 'DC',
            city: 'Washington',
            location: {
                title: '7th & 4th and Jefferson & Madison',
                sub_title: '',
            },
        },
        {
            mobile_state_name: 'WA',
            state: 'Washington',
            city: 'Port Townsend',
            location: {
                title: 'Haller Fountain on Washington and Taylor ',
                sub_title: 'Port Townsend, WA 98368',
            },
        },
        {
            mobile_state_name: 'WI',
            state: 'Wisconsin',
            city: 'Milwaukee',
            location: {
                title: 'Museum Center Park',
                sub_title: '910 E Michigan St, Milwaukee, WI 5320',
            },
        },
    ],
};

export default data;
